var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M457.4,438.2c-7.1,7.1-14.2,14.3-21.4,21.4c-12.7,12.4-25.1,12.4-37.7-0.2c-46.7-46.6-93.3-93.2-139.8-139.9 c-2.5-2.5-4.4-5.6-7.2-9.3c-4.3,4.1-6.7,6.3-8.9,8.6c-46.2,46.2-92.5,92.5-138.7,138.7c-15.3,15.3-26.5,15.2-41.8,0.1 c-6.7-6.7-13.5-13.5-20.2-20.2c-14.1-14.2-14.1-26-0.1-40c46.6-46.6,93.2-93.2,139.8-139.9c2.3-2.3,4.4-4.6,7.1-7.5 c-2.7-2.9-4.8-5.2-7.1-7.5c-46.4-46.4-92.8-92.9-139.2-139.3C27.3,88.5,27.4,77,42.3,62.1c7.1-7.1,14.2-14.3,21.4-21.4 c13-12.8,25.3-12.9,38.3,0.1c46.9,46.8,93.6,93.6,140.4,140.4c2.3,2.3,4.6,4.4,7.6,7.2c2.8-2.5,5.2-4.6,7.4-6.9 c46.4-46.4,92.8-92.8,139.3-139.2c14.9-14.9,26.3-14.9,41.2-0.2c6.6,6.5,13.1,13.1,19.7,19.7c15.3,15.3,15.4,26.7,0.2,41.8 c-46.2,46.3-92.4,92.5-138.7,138.6c-2.3,2.3-5.5,3.7-8.9,5.9c4.1,4.4,6.1,6.9,8.3,9.1c46.4,46.4,92.9,92.9,139.3,139.3 C472.8,411.6,472.7,423,457.4,438.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.2df56241ca2eb7d70a8a7aaaf0296956.svg";
export { ForwardRef as ReactComponent };